import { render, staticRenderFns } from "./BaseDrawerMenuItem.vue?vue&type=template&id=79b7b479"
import script from "./BaseDrawerMenuItem.vue?vue&type=script&lang=js"
export * from "./BaseDrawerMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports